import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles'
import {PanelItem} from '../../../components'
import Typography from 'material-ui/Typography'

const styles = theme => ({
  PanelItem: {
    background: theme.palette.primary.main,
  },
  Label: {
    color: theme.palette.common.white,
  },
})

const FlowSummaryLastPanelItem = ({classes, rows, ...props}) => (
  <PanelItem {...props} classes={{Item: classes.PanelItem}} style={{display: 'block'}}>
    {rows.map((r, i) => (
      <div key={i} style={{display: 'flex', width: '100%'}}>
        <div style={{flex: 1}}>
          <Typography variant={'body2'} className={classes.Label}>{r.label.toUpperCase()}</Typography>
        </div>
        <div style={{flex: 1}}>
          <Typography
            variant={'body2'}
            color={r.valueColor}
            align={'right'}
            className={r.valueColor ? null : classes.Label}
          >
            {r.value}
          </Typography>
        </div>
      </div>
    ))}
  </PanelItem>
)

FlowSummaryLastPanelItem.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
    valueColor: PropTypes.string,
  })).isRequired,
}

export default withStyles(styles, {withTheme: true})(FlowSummaryLastPanelItem)



// WEBPACK FOOTER //
// ./src/sections/flow/components/flowSummaryLastPanelItem.jsx